import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Image } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as AccessModalActions from "../../../envStore/actions/accessModal";
import * as UserActions from "../../../../store/actions/user";

//STYLES
import * as navBarStyles from "./styles/browserNavBar";

//NAV METHODS
import pageNavigation from "./navBarClickMethods";

//IMAGES
import logo from "./images/logo.jpg";

function BrowserNavBar() {
    const dispatch = useDispatch();
    const [profileSubMenu, setProfileSubMenu] = useState(false);

    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const user = useSelector((state) => state.user);
    const printingShop = useSelector((state) => state.printingShop);

    const navigate = useNavigate();

    function handleSignIn() {
        const actions = { action: "getBasket", data: {} };
        dispatch(AccessModalActions.LogActionsAndSignIn(actions));
    }

    function handleToggleProfileSubMenu() {
        setProfileSubMenu(!profileSubMenu);
    }

    function handleCloseProfileSubMenu() {
        setProfileSubMenu(false);
    }

    function handleCartOnClick() {
        navigate("./basket");
    }

    function handleYourProfileClick() {
        setProfileSubMenu(false);
        navigate("./profile/overview/orders");
    }

    function handleSignOutClick() {
        setProfileSubMenu(false);
        Axios.post("/userLogin/logout")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.message === "User logged out") {
                    dispatch(UserActions.UpdateAuth(false));
                    dispatch(UserActions.UpdateID(""));
                    dispatch(UserActions.UpdateName(""));
                    dispatch(UserActions.UpdateEmail(""));
                    dispatch(UserActions.UpdateType(""));

                    dispatch(AccessModalActions.SignOutMethod("clearBasketInferface"));

                    navigate("./");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <div style={navBarStyles.body}>
            <Row>
                <Col md={4}>
                    <Row>
                        <Col style={navBarStyles.navTitle} onClick={() => pageNavigation("/", navigate)}>
                            <Image src={logo} style={navBarStyles.imageSize} />
                            High-View Studios Shop
                        </Col>
                    </Row>
                </Col>
                <Col m={8}>
                    <Row>
                        <Col style={navBarStyles.navButtons}>
                            {user.auth ? (
                                <div style={navBarStyles.navbarSignedIn}>
                                    <div style={navBarStyles.basket}>
                                        <i onClick={handleCartOnClick} className="fa-solid fa-cart-shopping"></i>
                                        {printingShop.basketItemTotal}
                                    </div>
                                    <div style={navBarStyles.profileButtons} onClick={handleToggleProfileSubMenu}>
                                        <i className="fa-regular fa-circle-user"></i>
                                    </div>
                                </div>
                            ) : (
                                <div style={navBarStyles.navSignIn} onClick={handleSignIn}>
                                    Sign in &gt; <i className="fa-regular fa-user fa-lg"></i>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
            {profileSubMenu && (
                <div style={navBarStyles.subNavStyle}>
                    <div style={navBarStyles.subMenuButton} onClick={handleYourProfileClick}>
                        Your Profile
                    </div>
                    <hr style={navBarStyles.lineSetparator} />
                    <div style={navBarStyles.subMenuButton} onClick={handleSignOutClick}>
                        Sign Out
                    </div>
                </div>
            )}
        </div>
    );
}

export default BrowserNavBar;
